import React from 'react';

export function slaFromPrazo(prazo) {
  if (!prazo) return { sla: 'sem_prazo', diasRestantes: null };
  const raw = String(prazo).slice(0, 10);
  const due = new Date(`${raw}T00:00:00`);
  if (Number.isNaN(due.getTime())) return { sla: 'sem_prazo', diasRestantes: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dias = Math.round((due.getTime() - today.getTime()) / 86400000);
  if (dias < 0) return { sla: 'vencido', diasRestantes: dias };
  if (dias <= 3) return { sla: 'atencao', diasRestantes: dias };
  return { sla: 'no_prazo', diasRestantes: dias };
}

export function tramitacaoDueDate(item) {
  if (!item?.data_entrada) return null;
  const start = new Date(item.data_entrada);
  if (Number.isNaN(start.getTime())) return null;
  const days = Number(item.prazo_dias) || 15;
  start.setDate(start.getDate() + days);
  return start.toISOString().slice(0, 10);
}

const STYLES = {
  vencido: 'bg-red-100 text-red-800',
  atencao: 'bg-amber-100 text-amber-800',
  no_prazo: 'bg-emerald-100 text-emerald-800',
  sem_prazo: 'bg-gray-100 text-gray-600',
};

function labelFor({ sla, diasRestantes, idadeDias }) {
  if (sla === 'vencido') {
    const n = Math.abs(diasRestantes || 0);
    return n === 1 ? 'Vencido há 1 dia' : `Vencido há ${n} dias`;
  }
  if (sla === 'atencao') {
    if (diasRestantes === 0) return 'Vence hoje';
    return diasRestantes === 1 ? '1 dia restante' : `${diasRestantes} dias restantes`;
  }
  if (sla === 'no_prazo') {
    return diasRestantes === 1 ? '1 dia restante' : `${diasRestantes} dias restantes`;
  }
  if (idadeDias != null) {
    return idadeDias === 1 ? 'Aberta há 1 dia' : `Aberta há ${idadeDias} dias`;
  }
  return 'Sem prazo';
}

export default function SlaBadge({ prazo, sla, diasRestantes, idadeDias, className = '' }) {
  const computed = sla ? { sla, diasRestantes } : slaFromPrazo(prazo);
  const tone = STYLES[computed.sla] || STYLES.sem_prazo;
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${tone} ${className}`}>
      {labelFor({ ...computed, idadeDias })}
    </span>
  );
}
